export const iconFontAwesomeDesignLayerGroup = (
	<i className="fa-solid fa-layer-group"></i>
);
